export default __webpack_public_path__ + "static/DC_logo@2x-6f4aedcfe71dde76e69553f18e158cd7.png";